// extracted by mini-css-extract-plugin
export var main = "d236e2bf63cb6418cc3c29ab0194f0f8-css";
export var table = "abee05977585e87f2717ae34ae30e631-css";